var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalance24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgBalance24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-120v-80h360v-447q-26-9-45-28t-28-45H240l120 280q0 50-41 85t-99 35-99-35-41-85l120-280h-80v-80h247q12-35 43-57.5t70-22.5 70 22.5 43 57.5h247v80h-80l120 280q0 50-41 85t-99 35-99-35-41-85l120-280H593q-9 26-28 45t-45 28v447h360v80zm585-320h150l-75-174zm-520 0h150l-75-174zm335-280q17 0 28.5-11.5T520-760t-11.5-28.5T480-800t-28.5 11.5T440-760t11.5 28.5T480-720"
  })));
};
export default SvgBalance24DpE3E3E3Fill0Wght400Grad0Opsz24;